export default "__VITE_ASSET__DzBNSvCB__"